module.exports = __webpack_public_path__ + "static/media/tableText3.4277e300.png";